import apiFetch from '../apiFetch'

export default function (token, chargeId) {
  return apiFetch({ endPoint: `DocumentChargeInfo/${chargeId}/info`, method: 'GET', body: null, token: token })
}
